import React from "react";
import { Link } from "react-router-dom";
import "./HomeAds.css";

const alagozLogo = require("images/alagoz-holding.png");

const Arrow = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
    <path d="M4 12h16M14 6l6 6-6 6" />
  </svg>
);

// Full-width "Reklam Ver" leaderboard banner.
export function ReklamLeaderboard() {
  return (
    <div className="container my-4">
      <div className="ad-leaderboard">
        <span className="ad-label">Reklam</span>
        <div className="ad-deco" />
        <div className="ad-deco2" />
        <div className="ad-lb-text">
          <h3>Markanız milyonlarca alıcıya ulaşsın</h3>
          <p>
            Anasayfa reklam alanları kiralanabilir. Hemen yerinizi ayırtın,
            reklam ekibimiz size en kısa sürede ulaşsın.
          </p>
        </div>
        <Link className="ad-lb-cta" to="/reklam/iletisim">
          Reklam Ver <Arrow />
        </Link>
      </div>
    </div>
  );
}

// Sticky right-rail ads: Alagöz Holding sponsor card + bookable slot.
export function AlagozAdRail() {
  return (
    <aside className="ad-rail">
      <div className="sky-ad">
        <span className="ad-label">Reklam</span>
        <div className="brand-wrap">
          <img src={alagozLogo} alt="Alagöz Holding" className="brand-logo" />
        </div>
        <div className="body">
          <div className="k">Alagöz Holding</div>
          <div className="h">Geleceğe değer katan yatırımlar</div>
          <div className="desc">
            İlaç, enerji, madencilik, havacılık ve kimya başta olmak üzere
            farklı sektörlerdeki güçlü iştirakleriyle yarım asra yakın tecrübe.
          </div>
          <a
            className="cta"
            href="https://www.alagozholding.com.tr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Keşfet <Arrow />
          </a>
        </div>
      </div>

      <Link className="sky-bookable" to="/reklam/iletisim">
        <span className="ad-label">Reklam</span>
        <div className="t">Reklam Alanı</div>
        <div className="s">Bu alan markanız için ayrılabilir</div>
        <div className="dims">300 × 250</div>
        <div className="book-cta">Reklam Ver →</div>
      </Link>
    </aside>
  );
}
